module.exports = __webpack_public_path__ + "static/Tastea8-a5237d97679d550f5b9f4eeb9dd740ce.jpg";